module.exports = __webpack_public_path__ + "static/media/logo-dark.d1c1a657.svg";